<div
  id="default-page-assistance-parent"
  class="page-layout blank"
  class="page-layout simple"
  fxLayout="column">
  <!-- HEADER -->
  <div class="header header-assistance">
    <div
      class="name"
      [@animate]="{ value: '*', params: { delay: '100ms', x: '-25px' } }">
      {{ 'SUPPORT-ICT.TITLE' | translate }}
    </div>
  </div>
  <!-- / HEADER -->
  <div
    id="default-page-assistance"
    fxLayout="column"
    fxLayoutAlign="start center"
    style="overflow: auto">
    @if (!isFormOpened) {
      <div class="tile-container">
        <div class="tile" style="background-color: #f44336; color: white">
          <mat-icon class="icon-large">help</mat-icon>
          <div class="tile-content">
            <div class="tile-title">{{ 'SUPPORT-ICT.TITLE' | translate }}</div>
            <div class="tile-description">
              {{ 'SUPPORT-ENT.ICTVS.MESSAGE' | translate }}
            </div>
            <button
              mat-button
              class="tile-button"
              style="
                color: black !important;
                background-color: white !important;
                margin-bottom: 10px;
              "
              (click)="redirectToSupport()">
              {{ 'SUPPORT-ICT.TITLE' | translate }}
            </button>
          </div>
        </div>
        <div class="tile">
          <mat-icon class="icon-large">domain</mat-icon>
          <div class="tile-title-primary">
            {{ 'SUPPORT-ENT.DIRECTIONS-TEACHERS.TITLE' | translate }}
          </div>
          <div class="sub-tile">
            <div class="tile-content">
              <div class="tile-title-secondary">
                {{ 'SUPPORT-ENT.EDUID-FORMS.EDUID' | translate }}
              </div>
              <div class="tile-description-wide">
                {{ 'SUPPORT-ENT.EDUID-FORMS.EDUID_MESSAGE' | translate }}
              </div>
              <button
                mat-button
                class="tile-button"
                [disabled]="isTicketingDisabled"
                [ngStyle]="{ opacity: isTicketingDisabled ? 0.2 : 1 }"
                (click)="redirectServiceNow()">
                {{ 'SUPPORT-ENT.EDUID-FORMS.BTN-EDUID' | translate }}
              </button>
            </div>
          </div>
        </div>
        <div class="tile">
          <mat-icon class="icon-large">domain</mat-icon>
          <div class="tile-title-primary">
            {{ 'SUPPORT-ENT.DIRECTIONS-TEACHERS.TITLE' | translate }}
          </div>
          <div class="sub-tile">
            <div class="tile-content">
              <div class="tile-title-secondary">
                {{ 'SUPPORT-ENT.EDUID-FORMS.EDUID_NOACCESS' | translate }}
              </div>
              <div class="tile-description-wide">
                {{ 'SUPPORT-ENT.EDUID-FORMS.MESSAGE-FORMS' | translate }}
              </div>
              <button
                mat-button
                class="tile-button"
                [disabled]="isTicketingDisabled"
                [ngStyle]="{ opacity: isTicketingDisabled ? 0.2 : 1 }"
                (click)="openForms()">
                {{ 'SUPPORT-ENT.EDUID-FORMS.BTN-FORMS' | translate }}
              </button>
            </div>
          </div>
        </div>
        <div class="tile">
          <mat-icon class="icon-large">person</mat-icon>
          <div class="tile-content">
            <div class="tile-title">
              {{ 'SUPPORT-ENT.STUDENTS.TITLE' | translate }}
            </div>
            <div class="tile-description">
              {{ 'SUPPORT-ENT.STUDENTS.MESSAGE' | translate }}
            </div>
          </div>
        </div>
        <div class="tile">
          <mat-icon class="icon-large">supervisor_account</mat-icon>
          <div class="tile-content">
            <div class="tile-title">
              {{ 'SUPPORT-ENT.PARENTS.TITLE' | translate }}
            </div>
            <div class="tile-description">
              {{ 'SUPPORT-ENT.PARENTS.MESSAGE' | translate }}
            </div>
          </div>
        </div>
        <div class="tile" style="background-color: #262626; color: white">
          <mat-icon class="icon-large-ping">location_on</mat-icon>
          <div class="tile-content">
            <div class="tile-title">
              {{ 'SUPPORT-ENT.ICTVS.TITLE' | translate }}
            </div>
            <div class="tile-description">
              {{ 'SUPPORT-ENT.ICTVS.ADDRESS' | translate }}<br />{{
                'SUPPORT-ENT.ICTVS.CITY' | translate
              }}
            </div>
          </div>
        </div>
      </div>
    } @else {
      <app-servicenow-form
        (hasCloseForm)="actionForm($event)"
        [@animate]="{
          value: '*',
          params: { delay: '50ms', y: '25px' },
        }"></app-servicenow-form>
    }
  </div>
</div>
